module.exports = __webpack_public_path__ + "img/w3_spinner_light.f1ce62de.png";